import React from "react";
import { Box, Stack, Typography, CircularProgress } from "@mui/material";

import { formatDate, getUserRoleString } from "../../../../utils/format";
import {
  TOKENS,
  DetailDrawer,
  Section,
  Monogram,
  StatusPill,
} from "../../../../components/pages/_new/super/design";

const Field = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        color: TOKENS.fg3,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        mb: 0.25,
      }}
    >
      {label}
    </Typography>
    <Typography sx={{ fontSize: 13.5, color: TOKENS.fg1 }}>{value || "—"}</Typography>
  </Box>
);

function ViewUserModal({ open, handleClose, user, loading }) {
  const fullName = user ? `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || user?.email : "";
  const status = user?.isDeleted ? "Suspended" : "Active";

  return (
    <DetailDrawer
      open={open}
      onClose={handleClose}
      title={loading || !user ? "User detail" : fullName}
      subtitle={user?.email}
      headerChips={user ? [<StatusPill key="s" status={status} />] : undefined}
    >
      {loading || !user ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Box>
          <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
            <Monogram name={fullName} size={48} radius={12} />
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 600, color: TOKENS.fg1 }}>{fullName}</Typography>
              <Typography sx={{ fontSize: 12.5, color: TOKENS.fg2 }}>{user?.email}</Typography>
            </Box>
          </Stack>

          <Section label="Profile">
            <Field label="Name" value={fullName} />
            <Field label="Title" value={user?.title} />
            <Field label="Role" value={getUserRoleString(user?.role)} />
          </Section>

          <Section label="Account">
            <Field label="Email" value={user?.email} />
            <Field label="Verified" value={user?.isVerified ? "Yes" : "No"} />
            <Field label="Created" value={user?.created ? formatDate(user.created) : ""} />
          </Section>
        </Box>
      )}
    </DetailDrawer>
  );
}

export default ViewUserModal;
